import { render, staticRenderFns } from "./Scblock.vue?vue&type=template&id=52c5449d&style=height%3A100%25"
import script from "./Scblock.vue?vue&type=script&lang=js"
export * from "./Scblock.vue?vue&type=script&lang=js"
import style0 from "./Scblock.vue?vue&type=style&index=0&id=52c5449d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports